const REVIEWS = [
  {
    user: '健身新人小张',
    role: '《健身教练》追更读者',
    avatar: '张',
    content:
      '在073漫画网看了两年漫画了，更新稳定从不鸽子，画质也清晰，下拉式阅读特别舒服，下班路上刷两话已成习惯。',
    rating: 5,
  },
  {
    user: '爱看漫画的教练',
    role: '职业健身教练',
    content:
      '作为同行，最服气的是《健身教练》的专业度，动作讲解严谨、饮食干货靠谱，还能让会员边看漫画边学健身，强烈推荐。',
    rating: 5,
  },
  {
    user: '夜猫子读者',
    role: '平台注册读者',
    content:
      '半夜想看漫画，随手点开073漫画网居然秒开，加载快没广告，手机下拉式阅读体验一流，已收藏十几部作品了。',
    rating: 4,
  },
];

const STATS = [
  { value: '4.9', label: '综合评分', icon: 'ri-star-fill' },
  { value: '12.8万', label: '读者评价', icon: 'ri-chat-3-line' },
  { value: '98.6%', label: '好评率', icon: 'ri-thumb-up-line' },
  { value: '3年+', label: '稳定运营', icon: 'ri-shield-check-line' },
];

export default function Reviews() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20" aria-label="读者口碑">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
              Reputation
            </span>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">读者口碑，是最好的广告</h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            无需宣传语，每一句真实评价都是我们前进的动力。感谢每一位在073漫画网留下足迹的读者。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((stat) => (
            <div key={stat.label} className="flex items-center gap-4 rounded-lg bg-background-50 px-5 py-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-xl text-accent-700">
                <i className={stat.icon} aria-hidden="true" />
              </span>
              <div>
                <p className="font-heading text-2xl text-foreground-950">{stat.value}</p>
                <p className="mt-0.5 text-xs text-foreground-600">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {REVIEWS.map((review) => (
            <figure key={review.user} className="rounded-lg bg-background-50 p-5">
              <div className="flex items-center gap-2 text-secondary-500">
                {Array.from({ length: 5 }, (_, i) => (
                  <i
                    key={i}
                    className={i < review.rating ? 'ri-star-fill' : 'ri-star-line text-foreground-300'}
                    aria-hidden="true"
                  />
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-800">
                “{review.content}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-primary-700">
                  {review.avatar}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-950">{review.user}</p>
                  <p className="text-xs text-foreground-600">{review.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}